import { BaselineThresholdPage } from './components/BaselineThresholdPage';
import './index.scss';

const BaselineThreshold = () => {
  return <BaselineThresholdPage />;
};

export default BaselineThreshold;
